import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import LinkSwitcher from '@/components_new/LinkSwitcher.vue'
import { LOCALE_TITLES } from '@/i18n/helpers'
import { AvailableLocale } from '@/i18n/types'

interface LocaleSwitcherProps {
    locale: AvailableLocale
    href: string
    isSelected: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSwitcher',
  props: {
    locale: {},
    href: {},
    isSelected: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localeName = computed(() => LOCALE_TITLES[props.locale])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LinkSwitcher, {
    title: localeName.value,
    icon: _ctx.locale,
    externalTo: props.href,
    dataInterfaceTarget: "switch-locale",
    isSelected: props.isSelected,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', props.locale)))
  }, null, 8, ["title", "icon", "externalTo", "isSelected"]))
}
}

})